import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { all, put, select } from 'redux-saga/effects';
import { businessAdminRole, businessUserRoles, routes, managerRole } from '../../../../constants';
import { businessActions } from '../../business';
import { apiActionResult, apiActions as commonApiActions } from "../../common";
import { authTokenSelector } from '../../session';
import { taskActions } from '../../task';
import { API_ENDPOINT } from './endpoints';
import getDataFinishedConfig from './getDataFinished';
import getDataStartedConfig from './getDataStarted';
import getProfile from './getProfile';
import getQualifications from './getQualifications';
import getSubscriptionConfig, { apiAction as getSubscriptionApiAction } from './getSubscription';
import { apiAction as getUserAfsLicencesApiAction } from './getUserAfsLicences';
import { userActionTypes } from './util';

const actions = createActions({
  USER: {
    GET: (userId) => ({ userId }),
    API: {
      GET: userActionTypes((response) => ({
        ...response.details.user,
        avatarUrl: response.details.avatarUrl,
        roleAssignments: response.roleAssignments,
        teamMemberRoles: response.teamMemberRoles
      }))
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(API_ENDPOINT, authToken, actions.user.api.get)

export function* getApiUser(authToken) {
  if (authToken.idToken) {
    yield put(getDataStartedConfig.action.getData.started());
    yield put(apiAction(authToken));

    const getUserResult = yield apiActionResult(actions.user.api.get);

    // Try to fetch User's Businesses details.
    yield put(businessActions.business.getBusinesses());

    yield apiActionResult(businessActions.business.api.getBusinesses);

    // Gets associated data for the authenticated User.
    if (getUserResult.success) {
      const businessAdminUserRole = businessAdminRole(fp.get('payload.user.roleAssignments')(getUserResult.success));
      const managerUserRole = managerRole(fp.get('payload.user.roleAssignments')(getUserResult.success))
      const userRolesInBusiness = businessUserRoles(fp.get('payload.user.roleAssignments')(getUserResult.success));
      const isUserAssociatedWithBusiness = !fp.isEmpty(userRolesInBusiness);

      if (businessAdminUserRole) {
        yield put(businessActions.business.getInvitations(businessAdminUserRole.businessId));
        yield put(businessActions.business.getSubscription(businessAdminUserRole.businessId));
        yield put(businessActions.business.getTeamMembers(businessAdminUserRole.businessId));

        yield apiActionResult(businessActions.business.api.getSubscription);
      }
      else if (managerUserRole) {
        yield put(businessActions.business.getInvitations(managerUserRole.businessId));
        yield put(businessActions.business.getSubscription(managerUserRole.businessId));
        yield put(businessActions.business.getTeamMembers(managerUserRole.businessId));

        yield apiActionResult(businessActions.business.api.getSubscription);
      }
      else {
        yield put(getSubscriptionApiAction(authToken));

        yield apiActionResult(getSubscriptionConfig.action.user.api.getSubscription);
      }

      // Only fetches Business related resources if User is associated with any Business.
      if (isUserAssociatedWithBusiness) {
        yield all(fp.map(
          (role) => put(businessActions.business.getAfsLicences(role.businessId))
        )(userRolesInBusiness));
      }
      // Only get individual subscription details if User is NOT associated with any Business. 
      else {
        yield put(getUserAfsLicencesApiAction(authToken));
      }

      // fetch user task information
      yield put(taskActions.task.getCount());
      yield put(getQualifications.action.user.getQualifications());
      yield put(getProfile.action.user.getProfile());
    } else {
      yield put(push({ pathname: routes.app.userNotFound }))
    }

    yield put(getDataFinishedConfig.action.getData.finished());
  }
}

export function* getUser(action) {
  const authToken = yield select(authTokenSelector);

  yield* getApiUser(authToken);
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: getUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        roleAssignments: state.currentUser.roleAssignments,
        teamMemberRoles: state.currentUser.teamMemberRoles,
        ...action.payload.user
      },
      isFetching: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/get.js